import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  container: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    background: theme.palette.background.light,
  },
  logoContainer: {
    marginTop: theme.spacing(5),
    width: '100%',
    textAlign: 'center',
  },
  logo: {
    maxWidth: '100%',
  },
  messageContainer: {
    marginTop: theme.spacing(3),
    width: '100%',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
    borderRadius: 5,
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(5),
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  textFieldUnderline: {
    '&:before': {
      borderBottomColor: theme.palette.primary.light,
    },
    '&:after': {
      borderBottomColor: theme.palette.primary.main,
    },
    '&:hover:before': {
      borderBottomColor: `${theme.palette.primary.light} !important`,
    },
  },
  textField: {
    borderBottomColor: theme.palette.background.light,
  },
  formButtons: {
    width: '100%',
    marginTop: theme.spacing(4),
    justifyContent: 'center',
    alignItems: 'center',
  },
  loader: {
    margin: 'auto',
  },
  hint: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: '0.8rem',
  },
  error: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1),
    fontSize: '0.85rem',
  },
  actionsContainer: {
    justifyContent: 'center',
  },
}))
